module.exports = __webpack_public_path__ + "static/media/NutriDashReport2017.bd929d6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NutriDashReport2017.png
// module id = 672
// module chunks = 0